import React, { useState } from 'react'
import type { SyntheticEvent } from 'react'
import type { PopoverProps } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton } from './Button'
import Menu from './Menu'

export type ActionMenuProps = {
	open: boolean
	onOpen: () => void
	onClose: () => void
	children: React.ReactNode
}

const ActionMenu = ({
	open = false,
	onOpen,
	onClose,
	children,
}: ActionMenuProps) => {
	const [actionAnchorEl, setActionAnchorEl] =
		useState<PopoverProps['anchorEl']>(null)

	const handleOpenActionMenu = (e: SyntheticEvent) => {
		setActionAnchorEl(e.currentTarget)
		onOpen()
	}

	const handleCloseActionMenu = () => {
		setActionAnchorEl(null)
		onClose()
	}
	return (
		<>
			<IconButton
				size="small"
				edge="start"
				color="inherit"
				onClick={handleOpenActionMenu}
				sx={{
					'&:hover': {
						backgroundColor: 'transparent',
					},
				}}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				className="mt-8 sm:mt-10"
				anchorEl={actionAnchorEl}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={open}
				onClose={handleCloseActionMenu}
				keepMounted
			>
				{children}
			</Menu>
		</>
	)
}

export default ActionMenu
